
namespace RedBullMOBILE360.SMSCodes {

    @Serenity.Decorators.registerClass()
    export class SubscriptionCodesGrid extends Serenity.EntityGrid<SubscriptionCodesRow, any> {
        protected getColumnsKey() { return SubscriptionCodesColumns.columnsKey; }
        protected getDialogType() { return SubscriptionCodesDialog; }
        protected getIdProperty() { return SubscriptionCodesRow.idProperty; }
        protected getInsertPermission() { return SubscriptionCodesRow.insertPermission; }
        protected getLocalTextPrefix() { return SubscriptionCodesRow.localTextPrefix; }
        protected getService() { return SubscriptionCodesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }


        protected override getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                title: 'Export to Excel',
                grid: this,
                service: SubscriptionCodesService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit()
            }));

            return buttons;
        }
    }
}